"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Form = _interopRequireDefault(require("./Form"));
var _VirtualInputs = _interopRequireDefault(require("../atoms/VirtualInputs"));
var _templateObject, _templateObject2;
const _excluded = ["children", "name", "index"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const {
  useForm
} = _Form.default;
const propTypes = {
  children: _propTypes.default.element.isRequired,
  name: _propTypes.default.string,
  index: _propTypes.default.number.isRequired,
  value: _propTypes.default.string,
  checked: _propTypes.default.bool,
  disabled: _propTypes.default.bool
};
function CheckboxController(_ref) {
  let {
      children,
      name,
      index
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    control
  } = useForm();
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_VirtualInputs.default, {
    fields: [{
      name: "".concat(name, ".").concat(index, ".value"),
      defaultValue: props.value
    }]
  }), /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: "".concat(name, ".").concat(index, ".checked"),
    control: control,
    render: _ref2 => {
      let {
        field: {
          onChange,
          value
        }
      } = _ref2;
      const handleOnChange = () => {
        if (props.disabled) return;
        onChange(!value);
      };
      return /*#__PURE__*/_react.default.createElement(ItemWrapper, {
        onClick: handleOnChange
      }, /*#__PURE__*/_react.default.cloneElement(children, _objectSpread({
        checked: value
      }, props)));
    },
    defaultValue: props.checked
  }));
}
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
const ItemWrapper = _styled.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
CheckboxController.propTypes = propTypes;
var _default = exports.default = CheckboxController;